import { cn } from "@/utils/cn";
import type { ChipVariant } from "./Chip.types";

type ChipStyleProps = {
  variant?: ChipVariant;
};

export const getChipStyles = ({ variant = "default" }: ChipStyleProps) => {
  return {
    chip: cn(
      "inline-flex items-center justify-center rounded-[8px] border px-[10px] py-1 text-[10px] font-bold text-nowrap uppercase",

      {
        "bg-dark-400 text-dark-100 border-dark-100": variant === "default",
        "bg-warning-dark text-warning border-warning": variant === "warning",
        "bg-success-dark text-success border-success": variant === "success",
        "bg-error-dark text-error border-error": variant === "error",
        "bg-info-dark text-info border-info": variant === "info",
        "bg-primary/20 text-primary border-primary": variant === "primary",
        "bg-black text-primary border-dark-300": variant === "giants",
      }
    ),
  };
};
